export const resolveError = async (data) => {
    let message = '';
    await Object.entries(data.erros).map(listaDeErros => {
        message += `<strong>${listaDeErros[0]}</strong><br/>`
        listaDeErros[1].forEach(element => {
            message += `-${element}<br/>`
        });
    })
    return {
        title: data.message,
        message: message
    }
}

export const formatDate = (date) => {
    return date.split(' ')[0].split('-')[2]+'/'+date.split(' ')[0].split('-')[1]+'/'+date.split(' ')[0].split('-')[0]
}

export const validator = (param, payload) => {
    /* eslint-disable */ 
    switch(param){
        case 'email':
                // const re = /^[a-z0-9.]+@[a-z0-9]+\.[a-z]+(\.[a-z]+)?$/i;
                // return re.test(String(payload).toLowerCase());
                if(payload.length > 0){
                    return true
                }
    }
    /* eslint-enable */ 
}